import { render, staticRenderFns } from "./FifthPage.vue?vue&type=template&id=c5dc73f6&scoped=true&"
import script from "./FifthPage.vue?vue&type=script&lang=js&"
export * from "./FifthPage.vue?vue&type=script&lang=js&"
import style0 from "./FifthPage.vue?vue&type=style&index=0&id=c5dc73f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dc73f6",
  null
  
)

export default component.exports